import {TranslateSvc} from '../../../services/TranslateSvc';

class SubscriptionInvoiceHistoryContainer implements ng.IComponentController {
    loadingDetails: boolean;
    cardDetails: anm.CardDetails;
    apiErrorMessage: string;

    constructor(private TranslateSvc: TranslateSvc) {
    }

    $onChanges() {
        if (this.apiErrorMessage) {
            const error = this.apiErrorMessage.toLocaleLowerCase();
            this.apiErrorMessage = this.TranslateSvc.has(error) ? this.TranslateSvc.get(error) : error;
        }
    }
}

angular.module('animatronApp.SubscriptionInvoiceHistoryContainer', [])
    .component('subscriptionInvoiceHistoryContainer', {
        bindings: {
            loadingDetails: '<',
            cardDetails: '<',
            apiErrorMessage: '<'
        },
        controller: SubscriptionInvoiceHistoryContainer,
        templateUrl: require('settings/subscription/containers/subscription-invoice-history-container.html')
    });



// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/subscription/containers/SubscriptionInvoiceHistoryContainer.ts